import { apiBase } from "APIs/index";
import { notificationMiddleWare } from "utils/NotificationMiddleWare";

export const AI_get_taskAssignments = apiBase.createListInstance({
    endpoint: "/task-assignment",
    method: "get",
    reducer: "commonReducer",
    key: "id",
    middleware : notificationMiddleWare,
    reduxKey: "getTaskAssignments",
    action: "GET_ALL_TASK_ASSIGNMENTS",
    onSuccess : (data) => data
});

export const AI_taskAssignToMember = apiBase.createListInstance({
    endpoint: "/task-assignment",
    method: "post",
    reducer: "commonReducer",
    key: "id",
    // middleware : notificationMiddleWare,
    reduxKey: "AddTaskAssignments",
    action: "POST_TASK_ASSIGN_TO_MEMBER",
    onSuccess : (data) => data
});
export const AI_taskAssingAndWorkingMember = apiBase.createListInstance({
    endpoint: "/task-assignment-working-member",
    method: "put",
    reducer: "commonReducer",
    key: "id",
    // middleware : notificationMiddleWare,
    reduxKey: "AddTaskAssignmentsWorkingMember",
    action: "PUT_TASK_ASSIGN_TO_WORKING_MEMBER",
    onSuccess : (data) => data
});

export const AI_deleteAssignment = apiBase.createListInstance({
    endpoint: "/task-assignment/{id}",
    method: "delete",
    reducer: "commonReducer",
    key: "id",
    // middleware : notificationMiddleWare,
    reduxKey: "deleteTaskAssignments",
    action: "DELETE_TASK_ASSIGN_TO_MEMBER",
    onSuccess : (data) => data
});

export const AI_task_read_unread = apiBase.createListInstance({
    endpoint: "/mark-as-read-comment",
    method: "POST",
    reducer: "commonReducer",
    key: "id",
    reduxKey: "readUnreadTaskAssignments",
    action: "READ_UNREAD_TASK_ASSIGN_TO_MEMBER",
    onSuccess : (data) => data
});